import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth tokens are handled via httpOnly cookies (set by backend, not accessible from JS).
// `withCredentials: true` ensures cookies are sent with every request.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
